/* eslint-disable react/prop-types */
import React from "react";
import {
  TableContainer,
  TableCell,
  TableRow,
  TableHead,
  Table as MuiTable,
  Box,
  TableBody,
} from "@mui/material";
import PropTypes from "prop-types";
// import { styled } from "@mui/material/styles";
import Typography from "../../../../../components/common/new/Typography/Typography";
import style from "./tableStyle";

function Table({
  checkAllToggle,
  columns,
  rows,
  scrollable,
  columnCellStyle,
  headCellStyle,
  hasAction = false,
  headerStyle,
  // tableBodyTheme,
  // isSubscription,
  tableHeadCellStyle,
}) {
  return (
    <>
      <TableContainer
        style={{
          ...style.container,
          ...{ overflow: scrollable ? "auto" : "hidden" },
        }}
      >
        <MuiTable aria-label="collapsible table" stickyHeader>
          <TableHead sx={{ paddingTop: "1.4rem", ...headerStyle }}>
            <TableRow sx={{ padding: "1rem" }}>
              <TableCell
                align="left"
                colSpan={2}
                style={{
                  ...style.tableHeadCell,
                  ...columnCellStyle,
                  paddingLeft: "0px",
                  marginRight: "0px",
                  ...tableHeadCellStyle,
                }}
              />
              <TableCell
                align="left"
                colSpan={7}
                sx={{
                  ...style.tableHeadCell1,
                  ...columnCellStyle,
                  paddingLeft: "0px",
                  ...tableHeadCellStyle,
                }}
              >
                <Typography variant="small" weight={600}>
                  <Box
                    sx={{
                      marginLeft: "-11px",
                      borderLeft: "1px solid rgba(94, 94, 94, 1)",
                      borderRight: "1px solid rgba(94, 94, 94, 1)",
                    }}
                  >
                    {" "}
                    Members
                  </Box>
                </Typography>
              </TableCell>
              <TableCell
                align="left"
                colSpan={4}
                style={{
                  ...style.tableHeadCell,
                  ...columnCellStyle,
                  paddingLeft: "0px",
                  marginRight: "0px",
                  ...tableHeadCellStyle,
                }}
              />
            </TableRow>
            <TableRow sx={{ padding: "1rem" }}>
              {columns.map((col, index) => {
                const Component =
                  col.key === "checkBox" ? col.displayName : null;
                return (
                  <TableCell
                    key={col.displayName}
                    align="left"
                    rowSpan={col.rowspan ? col.rowSpan : 1}
                    colSpan={col.colSpan ? col.colSpan : 1}
                    style={{
                      ...style.tableHeadCell,
                      ...columnCellStyle,
                      ...tableHeadCellStyle,
                    }}
                  >
                    <Box
                      sx={{
                        borderRight:
                          index !== columns.length - 1
                            ? "1px solid rgba(94, 94, 94, 1)"
                            : "",
                        paddingRight: "0.6rem",
                      }}
                    >
                      <Typography
                        variant="small"
                        weight={600}
                        // style={headCellStyle}
                        style={{ ...headCellStyle, color: "black" }}
                      >
                        {Component ? (
                          <Component
                            sx={{ padding: "3px 14.8px" }}
                            onChange={(e) => checkAllToggle(e.target.checked)}
                          />
                        ) : (
                          col.displayName
                        )}
                      </Typography>
                    </Box>
                  </TableCell>
                );
              })}
              {hasAction ? <TableCell sx={style.tableHeadCell} /> : null}
            </TableRow>
          </TableHead>
          <TableBody
            // sx={style.tableBody}
            sx={{
              ...style.tableBody,
              "& .MuiTableCell-root": {
                // padding: "8px 8px 8px 8px",
              },
              "& .MuiTypography-root": {
                fontSize: "14px",
                color: "#000000",
              },
              "tr:nth-child(even)": {
                // backgroundColor: !isSubscription
                //   ? { backgroundColor: tableBodyTheme }
                //   : "#E8EDF4",
                backgroundColor: "#E8EDF4",
              },
            }}
          >
            {rows}
          </TableBody>
        </MuiTable>
      </TableContainer>
      {/* {!rows.length ? (
        <Box style={style.emptyList}>
          <Typography>No record found</Typography>
        </Box>
      ) : null} */}
    </>
  );
}

const propTypes = {
  checkAllToggle: PropTypes.fun,
  columns: PropTypes.arrayOf(PropTypes.objectOf()).isRequired,
  rows: PropTypes.arrayOf(PropTypes.element).isRequired,
  hasAction: PropTypes.bool,
  columnCellStyle: PropTypes.arrayOf(PropTypes.objectOf()),
  scrollable: PropTypes.bool,
  headCellStyle: PropTypes.objectOf(),
};

const defaultProps = {
  hasAction: false,
  scrollable: false,
  columnCellStyle: {},
  headCellStyle: {},
  checkAllToggle: () => {},
};

Table.propTypes = propTypes;
Table.defaultProps = defaultProps;

export default Table;
